module.exports = __webpack_public_path__ + "img/icon-report.6f0965e8.png";